export default {
  name: "Pin",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 31c-.31 0-.6-.14-.79-.39-.36-.47-8.91-11.5-9.94-16.8-.77-3.91-.1-6.67 2.23-9.25C9.48 2.36 12.74 1 16 1s6.52 1.36 8.5 3.56c2.33 2.58 2.99 5.34 2.23 9.26-1.03 5.3-9.58 16.33-9.94 16.8-.19.24-.48.38-.79.38zm0-28c-2.71 0-5.4 1.11-7.02 2.9-1.59 1.76-2.5 3.71-1.75 7.53C8 17.39 13.85 25.47 16 28.35c2.15-2.87 8-10.96 8.77-14.91.75-3.82-.16-5.77-1.75-7.53C21.4 4.11 18.71 3 16 3zm0 14c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3z",
  },
}
